// ======================================================================
// File Name       : ContentLinkingDetailSettingRegisterEditForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form, InputGroup, Row, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { change, Field, formValueSelector, getFormValues, reduxForm, submit } from 'redux-form';
import * as containerActions from '../../actions/ContainerAction';
import { postContainerGetStructureByCourseSecernId } from '../../actions/httpRequests/container';
import * as itemActions from '../../actions/ItemAction';
import { openModal } from '../../actions/ModalAction';
import { Category } from '../../components/Detail';
import FieldReduxForm from '../../components/ImportThumbnailReduxForm';
import TableHead from '../../components/TableHead';
import { CONTENT_TYPE } from '../../constants/ContentConstant';
import { PUBLIC_PERIOD_TYPE } from '../../constants/CourseConstants';
import {
  DEFAULT_DATE_FORMAT, DEFAULT_DATE_FORMAT_SEARCH, DEFAULT_DATE_FROM_TEXT, DEFAULT_DATE_TO_TEXT, MODE, VALIDATE_TYPE
} from '../../constants/index';
import {
  CHOSEN_THUMBNAIL_CONTENT, END_CONDITION_TYPE_FOR_ITEM , START_CONDITION_TYPE_FOR_ITEM
} from '../../constants/ItemConstant';
import * as ModalIds from '../../constants/ModalIds';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import UserAttributeRegisterEditContainer from '../../containers/userAttribute/UserAttributeRegisterEditContainer';
import {
  handleReportDateTime,
  parseDateForDetail, WRONG_MIN_REPORT_DATE, WRONG_MIN_RETURN_DATE, WRONG_REPORT_DATE
} from '../../utils/index';
import RenderField from '../../utils/ReduxFormUtils';


class ContentLinkingDetailSettingRegisterEditForm extends Component {
  constructor() {
    super();
    this.state = {};
    this.handleAdvanceSettingTitleClick = this.handleAdvanceSettingTitleClick.bind(this);
    this.handleUserAttributeTitleClick = this.handleUserAttributeTitleClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.formValues) {
      const imageFileSelectType = nextProps.formValues.imageFileSelectType;
      if (
        (imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.DEFAULT ||
          imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.NOTHING) &&
        nextProps.formValues.imageUploadFile
      ) {
        this.clearFileUpload();
      }
      const limitPublicPeriod = nextProps.formValues.limitPublicPeriod;
      if (limitPublicPeriod === PUBLIC_PERIOD_TYPE.NO_LIMIT) {
        this.props.change('publicPeriodFrom', '');
        this.props.change('publicPeriodTo', '');
      }
      // sprint_20230522_tma START
      if (
        nextProps.formValues.startConditionTypeForItem !==
        START_CONDITION_TYPE_FOR_ITEM.ACHIEVEMENT_RATE_CONDITION
      ) {
        this.props.change("progressRatioForItemStart", 0);
      }
      // sprint_20230522_tma END
    }
  }

  clearFileUpload() {
    try {
      document.getElementById('thumbnailImportItem').value = null;
      document.getElementById('fileNameUploadImageItem').value = '';
      this.props.dispatch(
        change('contentLinkingDetailSettingRegisterEditForm', 'imageUploadFile', null),
      );
    } catch (err) {
      console.log(err);
    }
  }

  handleOkBtnClick() {
    const { dispatch, editMode, formValues, contentType } = this.props;
    const { imageFileSelectType } = formValues;
    if (editMode === MODE.EDIT_MODE) {
      dispatch(itemActions.changeData(imageFileSelectType));
    }
    if (imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.DEFAULT) {
      dispatch(itemActions.getDefaultThumbnail(contentType));
    }
    dispatch(submit('contentLinkingDetailSettingRegisterEditForm'));
  }

  // sprint_20230522_tma START
  handleAddBtnClick() {
    const { dispatch, formValues, rootCourseSecernId } = this.props;
    // dispatch show popup
    postContainerGetStructureByCourseSecernId(rootCourseSecernId).then((res) => {
      dispatch(containerActions.getDataItemTree(res));
      dispatch(openModal(ModalIds.ITEM_TREE_CONTAINER));
      dispatch(itemActions.updateItem(formValues));
    });
  }

  removeItemInDialog(index) {
    const { dispatch } = this.props;
    dispatch(containerActions.removeItemListRelation(index));
  }
  // sprint_20230522_tma END

  handleAdvanceSettingTitleClick() {
    const { dispatch, advanceSettingExpand } = this.props;
    dispatch(itemActions.saveDetailSettingState('advanceSettingExpand', !advanceSettingExpand));
  }

  handleUserAttributeTitleClick() {
    const { dispatch, userAttributeExpanded } = this.props;
    dispatch(itemActions.saveDetailSettingState('userAttributeExpanded', !userAttributeExpanded));
  }

  render() {
    const {
      endConditionTypeForItem,
      contentType,
      isItemReport,
      contentSecernId,
      formValues,
      editMode,
      limitPublicPeriod,
      // sprint_20230522_tma START
      structures,
      selectedItemList,
      structuresByItem,
      startConditionTypeForItem,
      // sprint_20230522_tma END
      advanceSettingExpand,
      userAttributeExpanded,
    } = this.props;
    let fileName = '';
    let fileSize = 0;
    let imageUploadFile = null;
    let imageFileSelectType = CHOSEN_THUMBNAIL_CONTENT.DEFAULT;
    if (formValues) {
      try {
        if (
          formValues.imageUploadFile &&
          formValues.imageUploadFile[0] &&
          formValues.imageUploadFile[0].name &&
          formValues.imageUploadFile[0].size
        ) {
          fileName = formValues.imageUploadFile[0].name;
          fileSize = formValues.imageUploadFile[0].size;
          imageUploadFile = formValues.imageUploadFile;
        }
      } catch (err) {
        console.log(err);
      }

      if (formValues.imageFileSelectType) {
        imageFileSelectType = this.props.formValues.imageFileSelectType;
      }
    }

    // sprint_20230522_tma START
    const thead = [
      { title: "コース表示名称", sortBy: null },
      { title: "親セクション名", sortBy: null },
      { title: "操作", sortBy: null, width: 110 },
    ];

    let dataTable = null;
    if (selectedItemList && selectedItemList.length) {
      dataTable = selectedItemList.map((cur, index) => {
        let itemName = '';
        let boxNameWithItem = '';
        let boxIdWithItem = '';
        if (
          structures.bySecernId[cur.itemSecernId] &&
          Object.keys(structures.bySecernId).length
        ) {
          itemName = structures.bySecernId[cur.itemSecernId].structureName;
          boxIdWithItem = structures.bySecernId[cur.itemSecernId].parentBoxSecernId;
          boxNameWithItem = structures.bySecernId[boxIdWithItem].structureName;
        }
        return (
          <tr key={index}>
            <td>{itemName}</td>
            <td>{boxNameWithItem}</td>
            <td className="text-center">
              <i
                role="button"
                onClick={this.removeItemInDialog.bind(this, index)}
                className="bi bi-trash margin-top-10"
              />
            </td>
          </tr>
        );
      });
    }
    // sprint_20230522_tma END
    return (
      <Form onSubmit={this.props.handleSubmit} className="form-horizontal">
        <Category label="基本設定" />
        <Form.Group className="form-info">
          <Col sm={3} as={Form.Label}>
            コンテンツ識別ID
          </Col>
          <Col sm={9} className="padding-top-10">
            {contentSecernId}
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={3} as={Form.Label}>
            コース表示名称<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={9} className='padding-right-15'>
            <RenderField
              type="text"
              name="itemName"
              label="コース表示名称"
              validates={[VALIDATE_TYPE.REQUIRED]}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={3} as={Form.Label}>
            説明
          </Col>
          <Col sm={9} className='padding-right-15'>
            <Field
              name="description"
              component="input"
              type="text"
              maxLength="1024"
              className="form-control"
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={3} as={Form.Label}>
            公開ステータス
          </Col>
          <Col sm={9} className='padding-right-15'>
            <RenderField
              type="selectbox"
              name="publicStatus"
              label="公開ステータス"
              data={SELECT_BOX_DATA.PUBLIC_STATUS}
              normalizeRadio
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={3} as={Form.Label}>
            サムネイル画像
          </Col>
          <Col sm={9} className="padding-left-clear padding-top-10">
            {editMode === MODE.EDIT_MODE && (
              <Col sm={4}>
                <label htmlFor="nothing-content-thumbnail">
                  <Field
                    id="nothing-content-thumbnail"
                    name="imageFileSelectType"
                    component="input"
                    type="radio"
                    value={CHOSEN_THUMBNAIL_CONTENT.NOTHING}
                    parse={(value) => (value ? parseInt(value, 10) : "")}
                  />{" "}
                  変更しない
                </label>
              </Col>
            )}
            <Col sm={4}>
              <label htmlFor="default-content-thumbnail">
                <Field
                  id="default-content-thumbnail"
                  name="imageFileSelectType"
                  component="input"
                  type="radio"
                  value={CHOSEN_THUMBNAIL_CONTENT.DEFAULT}
                  parse={(value) => (value ? parseInt(value, 10) : "")}
                />{" "}
                {editMode === MODE.EDIT_MODE
                  ? "初期画像に変更"
                  : "初期画像で登録"}
              </label>
            </Col>
            <Col sm={4}>
              <label htmlFor="manual-content-thumbnail">
                <Field
                  id="manual-content-thumbnail"
                  name="imageFileSelectType"
                  component="input"
                  type="radio"
                  value={CHOSEN_THUMBNAIL_CONTENT.MANUAL}
                  parse={(value) => (value ? parseInt(value, 10) : "")}
                />{" "}
                手動で画像を変更
              </label>
            </Col>
          </Col>
        </Form.Group>
        <Form.Group
          className={
            imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.MANUAL
              ? "form-info"
              : "hidden-upload-file form-info"
          }
        >
          <Col sm={12} className='padding-bottom-7'>
            <FieldReduxForm
              name="imageUploadFile"
              label="サムネイル画像"
              inputId="thumbnailImportItem"
              validates={[
                VALIDATE_TYPE.REQUIRED,
                VALIDATE_TYPE.IMG_FILE,
                VALIDATE_TYPE.THUMBNAIL_SIZE,
              ]}
              value={imageUploadFile}
              fileName={fileName}
              fileSize={fileSize}
              clearFileUpload={this.clearFileUpload.bind(this)}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={12} className="padding-left-5">
            <a
              role="presentation"
              className={advanceSettingExpand ? "minute" : "plus"}
              onClick={this.handleAdvanceSettingTitleClick}
            >
              詳細設定
            </a>
          </Col>
        </Form.Group>
        {advanceSettingExpand && (
          <div>
            <Form.Group className="col-sm-12 form-info">
              <Col sm={3} as={Form.Label}>
                公開期間
              </Col>
              <Col sm={3} className="padding-top-10">
                <RenderField
                  type="radio"
                  className="padding-top-clear"
                  name="limitPublicPeriod"
                  value={PUBLIC_PERIOD_TYPE.NO_LIMIT}
                  inline
                  label="無期限"
                />
              </Col>
              <Col sm={3} className="padding-top-10">
                <RenderField
                  type="radio"
                  className="padding-top-clear"
                  name="limitPublicPeriod"
                  value={PUBLIC_PERIOD_TYPE.LIMIT}
                  inline
                  label="公開日指定"
                />
              </Col>

              <Col sm={12}>
                <Col sm={3} as={Form.Label} />
                <Col sm={3}>
                  <RenderField
                    name="publicPeriodFrom"
                    type="datetime"
                    validates={[VALIDATE_TYPE.DATE_TIME]}
                    normalizeDateTime
                    dateFormat={DEFAULT_DATE_FORMAT}
                    disabled={limitPublicPeriod === PUBLIC_PERIOD_TYPE.NO_LIMIT}
                  />
                </Col>
                <Col sm={1} className="text-center" as={Form.Label}>
                  ～
                </Col>
                <Col sm={3}>
                  <RenderField
                    name="publicPeriodTo"
                    type="datetime"
                    validates={[VALIDATE_TYPE.DATE_TIME]}
                    normalizeDateTime
                    dateFormat={DEFAULT_DATE_FORMAT}
                    disabled={limitPublicPeriod === PUBLIC_PERIOD_TYPE.NO_LIMIT}
                  />
                </Col>
              </Col>
              <Col sm={12}>
                <RenderField
                  name="dateTimeMinMaxPublicPeriod"
                  type="dateTimeMinMax"
                  validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                  keyDateFrom={"publicPeriodFrom"}
                  keyDateTo={"publicPeriodTo"}
                />
              </Col>
              {/* sprint_20230522 START */}
              <Col sm={12} className="margin-bottom-15">
                <Col sm={3} as={Form.Label}>
                  コンテンツ開始条件
                </Col>
                <Col sm={9} className="padding-top-10">
                  <RenderField
                    type="radio"
                    className="padding-top-clear"
                    name="startConditionTypeForItem"
                    value={START_CONDITION_TYPE_FOR_ITEM.NO_CONDITION}
                    inline
                    label="なし"
                    normalizeRadio
                  />
                </Col>
                <Col
                  sm={{
                    span: 9,
                    offset: 3,
                  }}
                >
                  <RenderField
                    type="radio"
                    className="padding-top-clear"
                    name="startConditionTypeForItem"
                    value={START_CONDITION_TYPE_FOR_ITEM.AND_CONDITION}
                    inline
                    label="指定されたコンテンツを全て完了"
                    normalizeRadio
                  />
                </Col>
                <Col
                  sm={{
                    span: 9,
                    offset: 3,
                  }}
                  className="padding-top-10"
                >
                  <RenderField
                    type="radio"
                    className="padding-top-clear"
                    name="startConditionTypeForItem"
                    value={START_CONDITION_TYPE_FOR_ITEM.OR_CONDITION}
                    inline
                    label="指定されたコンテンツのいずれかを完了"
                    normalizeRadio
                  />
                </Col>
                <Col
                  sm={{
                    span: 6,
                    offset: 3,
                  }}
                  className="padding-top-10"
                >
                  <RenderField
                    type="radio"
                    className="padding-top-clear"
                    name="startConditionTypeForItem"
                    value={
                      START_CONDITION_TYPE_FOR_ITEM.ACHIEVEMENT_RATE_CONDITION
                    }
                    inline
                    label="指定されたコンテンツの完了条件達成率"
                    normalizeRadio
                  />
                </Col>
                {startConditionTypeForItem ===
                  START_CONDITION_TYPE_FOR_ITEM.ACHIEVEMENT_RATE_CONDITION && (
                  <Col sm={3} className='padding-right-15'>
                    <InputGroup size="sm">
                      <Field
                        name="progressRatioForItemStart"
                        component="input"
                        type="number"
                        className="form-control"
                        min={0}
                        max={100}
                      />
                      <InputGroup.Text>%</InputGroup.Text>
                    </InputGroup>
                  </Col>
                )}
              </Col>
              {startConditionTypeForItem !==
                START_CONDITION_TYPE_FOR_ITEM.NO_CONDITION && (
                <>
                  <Row className="col-sm-12 margin-bottom-15 padding-left-15">
                    <Col sm={3} className="padding-top-10">
                      <Button
                        variant="primary"
                        className="btn-96"
                        onClick={this.handleAddBtnClick.bind(this)}
                      >
                        追加
                      </Button>
                    </Col>
                  </Row>
                  <Col sm={12} className="padding-left-15 padding-right-15">
                    <RenderField
                      type="requiredarray"
                      name="requiredarray"
                      validates={[
                        VALIDATE_TYPE.REQUIRED_ARRAY_LIST_ITEM_START_CONDITION,
                      ]}
                      keyArrayToCheck="selectedItemList"
                    />
                  </Col>
                  <Col sm={12} className="padding-left-15 padding-right-15">
                    <Table striped hover>
                      <thead>
                        <TableHead data={thead} />
                      </thead>
                      <tbody>{dataTable}</tbody>
                    </Table>
                  </Col>
                </>
              )}
              {/* sprint_20230522 END */}
              <Form.Group className="col-sm-12">
                <Col sm={3} as={Form.Label}>
                  コンテンツ完了条件
                </Col>
                <Col sm={9} className="padding-top-10">
                  <label htmlFor="achivement-rate-end-condition">
                    <Field
                      id="achivement-rate-end-condition"
                      name="endConditionTypeForItem"
                      component="input"
                      type="radio"
                      value={END_CONDITION_TYPE_FOR_ITEM.ACHIVEMENT_RATE}
                      parse={(value) => (value ? parseInt(value, 10) : "")}
                    />{" "}
                    あり
                  </label>
                  <label htmlFor="no-end-condition" className="margin-left-10">
                    <Field
                      id="no-end-condition"
                      name="endConditionTypeForItem"
                      component="input"
                      type="radio"
                      value={END_CONDITION_TYPE_FOR_ITEM.NOT_CONDITION}
                      parse={(value) => (value ? parseInt(value, 10) : "")}
                    />{" "}
                    なし
                  </label>
                </Col>
              </Form.Group>
              {endConditionTypeForItem ===
                END_CONDITION_TYPE_FOR_ITEM.ACHIVEMENT_RATE &&
                contentType === CONTENT_TYPE.DRILL && (
                  <Form.Group className="col-sm-12">
                    <Col
                      sm={{
                        span: 3,
                        offset: 3,
                      }}
                      className="padding-top-7"
                    >
                      <label htmlFor="not-use-achivement-rate">
                        <Field
                          id="not-use-achivement-rate"
                          name="achievementRate"
                          component="input"
                          type="radio"
                          value={false}
                          parse={(value) => value === "true"}
                        />
                        コンテンツ実施
                      </label>
                    </Col>
                    <Col sm={2} className="padding-top-7">
                      <label
                        htmlFor="use-achivement-rate"
                        className="float-start"
                      >
                        <Field
                          id="use-achivement-rate"
                          name="achievementRate"
                          component="input"
                          type="radio"
                          value
                          parse={(value) => value === "true"}
                          disabled={isItemReport}
                        />
                        正答率
                      </label>
                    </Col>
                    <Col sm={2}>
                      <InputGroup size="sm">
                        <Field
                          name="progressRatioForItemEnd"
                          component="input"
                          type="number"
                          className="form-control"
                          min={0}
                          max={100}
                          disabled={
                            contentType !== CONTENT_TYPE.DRILL || isItemReport
                          }
                        />
                        <InputGroup.Text>%</InputGroup.Text>
                      </InputGroup>
                    </Col>
                  </Form.Group>
                )}
              {isItemReport && (
                <div>
                  <Form.Group className="col-sm-12">
                    <Col sm={3} as={Form.Label}>
                      レポート提出期限
                    </Col>
                    <Col sm={4}>
                      <RenderField
                        name="reportDeadline"
                        type="datetime"
                        validates={[
                          VALIDATE_TYPE.DATE_TIME,
                          VALIDATE_TYPE.DATE_TIME_WITH_LIMIT,
                        ]}
                        normalizeDateTime
                        dateFormat={DEFAULT_DATE_FORMAT}
                        minMaxDateTxt={DEFAULT_DATE_TO_TEXT}
                        wrongPeriodTxt={WRONG_MIN_REPORT_DATE}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group className="col-sm-12">
                    <Col sm={3} as={Form.Label} className="padding-right-clear">
                      レポート結果返却予定日
                    </Col>
                    <Col sm={4}>
                      <RenderField
                        name="reportReturnPlanDate"
                        type="datetime"
                        validates={[
                          VALIDATE_TYPE.DATE_TIME,
                          VALIDATE_TYPE.DATE_TIME_WITH_LIMIT,
                        ]}
                        normalizeDateTime
                        dateFormat={DEFAULT_DATE_FORMAT}
                        minMaxDateTxt={DEFAULT_DATE_FROM_TEXT}
                        wrongPeriodTxt={WRONG_MIN_RETURN_DATE}
                      />
                    </Col>
                  </Form.Group>
                  <Col sm={12}>
                    <RenderField
                      name="dateTimeMinMax"
                      type="dateTimeMinMax"
                      validates={[VALIDATE_TYPE.REPORT_TIME_MIN_MAX]}
                      keyReportDeadline={"reportDeadline"}
                      keyReportReturnPlanDate={"reportReturnPlanDate"}
                      wrongPeriodTxt={WRONG_REPORT_DATE}
                      returnPlanDateTxt={DEFAULT_DATE_FROM_TEXT}
                      reportDeadlineTxt={DEFAULT_DATE_TO_TEXT}
                    />
                  </Col>
                </div>
              )}
            </Form.Group>
            <UserAttributeRegisterEditContainer
              titleClass="padding-left-20"
              leftClass="padding-left-45"
              expanded={userAttributeExpanded}
              onTitleClick={this.handleUserAttributeTitleClick}
            />
          </div>
        )}
        <Col sm={12} className="text-center padding-top-10">
          <Button
            style={{ marginRight: "5px" }}
            onClick={this.props.onBackBtnClick}
            className="btn-96"
            variant="default"
          >
            {"戻る"}
          </Button>
          <Button
            variant="primary"
            className="btn-96"
            onClick={this.handleOkBtnClick.bind(this)}
          >
            {"OK"}
          </Button>
        </Col>
      </Form>
    );
  }
}

const ReduxFormConnectedComponent = reduxForm({
  form: 'contentLinkingDetailSettingRegisterEditForm',
  enableReinitialize: true,
  touchOnChange: true,
})(ContentLinkingDetailSettingRegisterEditForm);

const mapStateToProps = (state, ownProps) => {
  const {
    itemName,
    description,
    publicStatus,
    publicPeriodFrom,
    publicPeriodTo,
    endConditionTypeForItem,
    progressRatioForItemEnd,
    contentInfo: { contentType, drillTypeForItem, contentSecernId },
    isItemReport,
    imageFileSelectType,
    imageUploadFile,
    limitPublicPeriod,
    startConditionTypeForItem,
    progressRatioForItemStart,
  } = state.item.edittingItem;
  const { editMode, edittingItem, advanceSettingExpand, userAttributeExpanded } = state.item;
  const { structures, selectedItemList, structuresByItem, rootCourseSecernId } = state.container;
  const { reportDeadline, reportReturnPlanDate } = state.report.editingReport || {
    reportDeadline: '',
    reportReturnPlanDate: '',
  };
  const format = DEFAULT_DATE_FORMAT;
  const dateTime = handleReportDateTime(reportReturnPlanDate, reportDeadline, format);
  edittingItem.publicPeriodFrom = parseDateForDetail(publicPeriodFrom, DEFAULT_DATE_FORMAT_SEARCH, '');
  edittingItem.publicPeriodTo = parseDateForDetail(publicPeriodTo, DEFAULT_DATE_FORMAT_SEARCH, '');

  return {
    formValues: getFormValues('contentLinkingDetailSettingRegisterEditForm')(state),
    initialized: true,
    initialValues: {
      itemName,
      description,
      publicStatus,
      limitPublicPeriod,
      publicPeriodFrom,
      publicPeriodTo,
      endConditionTypeForItem,
      progressRatioForItemEnd,
      achievementRate: parseInt(progressRatioForItemEnd, 10) > 0,
      reportDeadline: dateTime.dateTimeToTxt,
      reportReturnPlanDate: dateTime.dateTimeFromTxt,
      imageUploadFile,
      imageFileSelectType,
      startConditionTypeForItem,
      progressRatioForItemStart,
      selectedItemList,
    },
    contentSecernId,
    item: edittingItem,
    contentType,
    drillTypeForItem,
    limitPublicPeriod: formValueSelector('contentLinkingDetailSettingRegisterEditForm')(
      state,
      'limitPublicPeriod',
    ),
    endConditionTypeForItem: formValueSelector('contentLinkingDetailSettingRegisterEditForm')(
      state,
      'endConditionTypeForItem',
    ),
    isItemReport,
    editMode,
    structures,
    selectedItemList,
    structuresByItem,
    startConditionTypeForItem:formValueSelector('contentLinkingDetailSettingRegisterEditForm')(
      state,
      'startConditionTypeForItem',
    ),
    rootCourseSecernId,
    advanceSettingExpand,
    userAttributeExpanded,
  };
};

export default connect(mapStateToProps)(ReduxFormConnectedComponent);
